export enum ClientApplication {
  Admin = 'Admin',
  Teacher = 'Teacher',
  Student = 'Student',
}
